import { fork, all } from "redux-saga/effects";

import accountSaga from "./account/sagas";
import queueSaga from "./queue/sagas";

export default function* root() {
  yield all([fork(accountSaga), fork(queueSaga)]);
}
